// Inverse of calcDueDate (defined client-side in SuppliersPage.jsx).
//
// FORWARD: given payment_terms = "שוטף N" and invoice month, compute due date.
//   start_month = invoice_month + 1
//   day = N (bare שוטף → N=1)
//   while day > 30: day -= 30; start_month += 1
//   if day == 30: day = 1; start_month += 1   (30-day = 1st of next month)
//
// INVERSE (this file): given payment_terms and due date, compute the invoice
// month that would produce it under the forward calc. Returns 'YYYY-MM' or
// null. Returns null when: terms don't start with "שוטף", or the target day
// doesn't match what those terms produce (e.g. שוטף 30 always lands on day 1,
// never day 15).

// Strip "שוטף" prefix and parse the trailing number. Bare "שוטף" is treated
// as N=1 (matches calcDueDate's `isNaN(raw) || raw <= 0 ? 1 : raw`). Returns
// null for non-"שוטף" terms, empty/null input.
function parseShotefDays(paymentTerms) {
  if (!paymentTerms || typeof paymentTerms !== 'string') return null;
  const trimmed = paymentTerms.trim();
  if (!trimmed.startsWith('שוטף')) return null;
  const raw = parseInt(trimmed.replace('שוטף', '').trim(), 10);
  return isNaN(raw) || raw <= 0 ? 1 : raw;
}

// Given payment_terms and an ISO due date 'YYYY-MM-DD', return 'YYYY-MM' of
// the invoice month that would produce that due date — or null.
function requiredInvoiceMonth(paymentTerms, dueDateIso) {
  const N = parseShotefDays(paymentTerms);
  if (N == null) return null;
  if (!dueDateIso || typeof dueDateIso !== 'string') return null;
  const m = dueDateIso.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (!m) return null;
  const dueY = parseInt(m[1], 10);
  const dueM = parseInt(m[2], 10);
  const dueD = parseInt(m[3], 10);
  if (dueM < 1 || dueM > 12 || dueD < 1 || dueD > 31) return null;

  // Replay the forward calc to find what day + month-offset N produces.
  let day = N;
  let monthOffset = 1;            // start_month = invoice_month + 1
  while (day > 30) { day -= 30; monthOffset += 1; }
  if (day === 30) { day = 1; monthOffset += 1; }

  // If target day != produced day, no invoice month yields this due date.
  if (dueD !== day) return null;

  // invoice_month = due_month - monthOffset. Roll years as needed.
  let invM = dueM - monthOffset;
  let invY = dueY;
  while (invM < 1) { invM += 12; invY -= 1; }
  return `${invY}-${String(invM).padStart(2, '0')}`;
}

export { parseShotefDays, requiredInvoiceMonth };
